import styles from "../../../../pages/ClientDashboard/Profile/profile.module.css";

const STAT_LABELS = [
  { key: "jobsPosted", label: "Jobs Posted" },
  { key: "candidates", label: "Candidates" },
  { key: "hired", label: "Hired" },
];

export default function ProfileStatsBar({ stats }) {
  return (
    <div className={styles.statsBar}>
      {STAT_LABELS.map((stat, i) => (
        <div key={stat.label} style={{ display: "contents" }}>
          <div className={styles.statItem}>
            <div className={styles.statValue}>{stats?.[stat.key] ?? 0}</div>
            <div className={styles.statLabel}>{stat.label}</div>
          </div>
          {i < STAT_LABELS.length - 1 && <div className={styles.statDivider} />}
        </div>
      ))}
    </div>
  );
}
